export enum FormName {
  CONTACT_DETAILS = "contact-details",
  PERSONAL_DETAILS = "personal-details",
  NATIONALITY = "nationality",
  SMOKER = "smoker",
  GENDER = "gender",
  DATE_OF_BIRTH = "date-of-birth",
  OCCUPATION = "occupation",
  BMI_INFORMATION = "bmi-information",
  UNDERWRITING_QUESTIONS = "underwriting-questions",
  SUMMARY = "summary",
  INSURANCE_TERM = "insurance-term",
  INSURANCE_START_DATE = "insurance-start-date",
  INSURANCE_SUM = "insures-sum",
  BENEFICIARY_TYPE_SELECTOR = "beneficiary-type-selector",
  TERMS_ACCEPTED = "terms-accepted",
  EMPLOYMENT_TYPE = "employment-type",
  RISK_PROFILE = "risk-profile",
  INVESTMENT_PROFILE = "investment-profile",
  YEARLY_PREMIUM = "yearly-premium",
  INVESTMENT_BUDGET = "investment-budget",
  // pillar 3a
  SAVINGS_PLAN_SELECTOR = "savings-plan-selector",
  PILLAR_3A_PERSONAL_DETAILS = "pillar3a-personal-details",
  BROKER = "broker",
  PREMIUM_PAYMENT_FREQUENCY = "premium-payment-frequency",
  // shared
  EMAIL_VERIFICATION = "email-verification",
}
